export default "__VITE_ASSET__8ad32a07__"